import { defineStore } from "pinia";

import environment from "@/environment";
import Crud from "@/store/crud";
import CountryData from "@/store/country-data";
import { useLK } from "@/controllerLK/LKstore";
import { toTimestamp } from "@/tools/date-time-tools";

const crud = new Crud(
  environment.appConfig.baseApiUrl + "Analytics/category/dynamics/:projectId",
  "id",
  "",
  {}
);
const countryData = new CountryData();

export const useNewsStatDynamicCategoryStore = defineStore({
  id: "countryStatDynamicRubrics",
  state: () => ({
    ...crud.state,
    ...countryData.state,
  }),
  getters: {
    ...crud.getters,
    ...countryData.getters,
  },
  actions: {
    ...crud.actions,
    ...countryData.actions,
    async loadStat(dateFrom, dateTo, paramName, categoryIDs) {
      const lk = useLK();
      const params = new URLSearchParams();
      params.append("dateStart", toTimestamp(dateFrom));
      params.append("dateEnd", toTimestamp(dateTo));
      if (paramName && categoryIDs) {
        categoryIDs.forEach((id) => {
          params.append(paramName, id);
        });
      }
      return await this.loadCountryData({
        countryCode: lk.project.id,
        clear: true,
        params,
      });
    },
  },
});
